import {
  BaseBoxShapeUtil,
  HTMLContainer, Rectangle2d,
  TLBaseShape,
  BaseBoxShapeTool
} from "tldraw"

type ProtractorShape = TLBaseShape<
  "protractor",
  {
    w: number
    h: number
  }
>

export class ProtractorShapeUtil extends BaseBoxShapeUtil<ProtractorShape> {
  static override type = "protractor"

  getDefaultProps(): ProtractorShape["props"] {
    return {
      w: 400,
      h: 220,
    }
  }

  getGeometry(shape: ProtractorShape) {
    return new Rectangle2d({
      width: shape.props.w,
      height: shape.props.h,
      isFilled: true,
    })
  }


  component(shape: ProtractorShape) {
    const { w, h } = shape.props

    const baseHeight = 10

    const cx = w / 2
    const cy = h - baseHeight
    const radius = Math.min(w / 2, cy)

    const ticks = []

    for (let deg = 0; deg <= 180; deg++) {
      const rad = (deg * Math.PI) / 180

      const outerX = cx + radius * Math.cos(Math.PI - rad)
      const outerY = cy - radius * Math.sin(Math.PI - rad)

      let tickLength = 8
      if (deg % 10 === 0) tickLength = 18
      else if (deg % 5 === 0) tickLength = 12

      const innerX = cx + (radius - tickLength) * Math.cos(Math.PI - rad)
      const innerY = cy - (radius - tickLength) * Math.sin(Math.PI - rad)

      ticks.push(
        <line
          key={deg}
          x1={innerX}
          y1={innerY}
          x2={outerX}
          y2={outerY}
          stroke="black"
          strokeWidth={1}
        />
      )

      if (deg % 10 === 0) {
        const textRadius = radius - 30

        const tx = cx + textRadius * Math.cos(Math.PI - rad)
        const ty = cy - textRadius * Math.sin(Math.PI - rad)

        ticks.push(
          <text
            key={`text-${deg}`}
            x={tx}
            y={ty}
            fontSize={12}
            textAnchor="middle"
            dominantBaseline="middle"
          >
            {deg}
          </text>
        )

        const textRadius2 = radius - 60;
        const tx2 = cx + textRadius2 * Math.cos(Math.PI - rad)
        const ty2 = cy - textRadius2 * Math.sin(Math.PI - rad)

        ticks.push(
          <text
            key={`text-${deg}`}
            x={tx2}
            y={ty2}
            fontSize={12}
            textAnchor="middle"
            dominantBaseline="middle"
          >
            {180-deg}
          </text>
        )

      }
    }

    return (
      <HTMLContainer>
        <svg width={w} height={h}>

          {/* ticks and numbers */}
          {ticks}


          {/* rectangular base */}
          <rect
            x={cx - radius}
            y={cy}
            width={radius * 2}
            height={baseHeight}
            // fill="#f6e6b4"
            fill="rgba(246,230,180,0.3)"
            // stroke="#333"
            strokeWidth={2}
          />


          {/* semicircle */}
          <path
            d={`M ${cx - radius} ${cy}
                A ${radius} ${radius} 0 0 1 ${cx + radius} ${cy}`}
            // fill="#f6e6b4"
            fill="rgba(246,230,180,0.3)"
            stroke="#333"
            strokeWidth={1}
          />

          {/* baseline */}
          <line
            x1={cx - radius + 100}
            y1={cy}
            x2={cx + radius - 100}
            y2={cy}
            stroke="#333"
            strokeWidth={1}
          />

          {/*<line*/}
          {/*  x1={cx}*/}
          {/*  y1={cy}*/}
          {/*  x2={cx}*/}
          {/*  y2={cy - 20}*/}
          {/*  stroke="#333"*/}
          {/*  strokeWidth={1}*/}
          {/*/>*/}


          <circle
            cx={cx}
            cy={cy}
            r={3}
            fill={"black"}
          />


        </svg>
      </HTMLContainer>
    )
  }


  indicator(shape: ProtractorShape) {
    return (
      <rect
        width={shape.props.w}
        height={shape.props.h}
      />
    )
  }
}

export const ProtractorIcon = () => (
  <svg width={20} height={20} viewBox="0 0 20 20">
    {/* Semicircle */}
    <path
      d="M2,12 A8,8 0 0 1 18,12"
      fill="none"
      stroke="#333"
      strokeWidth={1.5}
    />
    {/* Baseline */}
    <line x1={2} y1={12} x2={18} y2={12} stroke="#333" strokeWidth={1.5} />
    {/* Angle ticks */}
    <line x1={2} y1={12} x2={3} y2={10} stroke="#333" strokeWidth={1} />
    <line x1={10} y1={4} x2={10} y2={12} stroke="#333" strokeWidth={1} />
    <line x1={18} y1={12} x2={17} y2={10} stroke="#333" strokeWidth={1} />
  </svg>
)

export class ProtractorTool extends BaseBoxShapeTool {
  static override id = "protractor"
  static override initial = "idle"
  shapeType = "protractor"
}